import styled from "styled-components";

export const SearchIconDefaultBox = styled.i`
    display: block;
    position: absolute;
    top: 50%;
    inset-inline-start: 0.95rem;
    transform: translateY(-50%) scaleX(-1);;
    width: 2rem;
    height: 2rem;
    z-index: 2;
    pointer-events: none;
    color: ${props => props.theme.colors.textLight};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        inset-inline-start: 1.6rem;
    }
`;